import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { Col, Input, Row, Button, FormGroup, InputGroup, InputGroupText, CustomInput } from 'reactstrap';
import { MessageConst } from '../../../../../helpers/messageConst';


const schema = yup.object({
    id: yup.number().transform((value) => (isNaN(value) ? 0 : value)).default(0),
    storageLocationName: yup.string().required('Please provide storage loction').nullable(),
});

const StorageRecForm = ({ onCancelClick, onSubmitClick, defaultValues, loading }) => {
    const { control, register, handleSubmit, setValue, setError, formState: { errors } } = useForm({
        defaultValues,
        mode: "all",
        resolver: yupResolver(schema)
    });
    const onSubmit = data => {
        const submitData = { ...defaultValues, ...data };
        onSubmitClick(submitData);
    };
    return (<>
        <form key="frmSl" className="g-3" onSubmit={(event) => {
            event.preventDefault();
            handleSubmit(onSubmit)(event);
        }}>
            <Row>
                <Col>
                    <label className="form-label" htmlFor='storageLocationName'>Storage Location Name*</label>
                    <input className="form-control" id="storageLocationName"
                        type="text" {...register("storageLocationName")}
                        maxLength={50} autoComplete='off' />
                    {errors.storageLocationName && <span className='text-danger fs--2'>{errors.storageLocationName.message}</span>}
                </Col>
            </Row>
            <Row className='flex-between-center mt-3'>
                <Col xs={'auto'}>
                    <button className="btn btn-danger btn-sm" type="button" onClick={(e) => { onCancelClick(e); }}>Cancel</button>
                </Col>
                <Col xs={'auto'}>
                    <Button color="primary" size='sm' type="submit" disabled={loading}>Save</Button>
                </Col>
            </Row>
        </form>
    </>)

}
export default StorageRecForm;